import React, { useState } from 'react';
import TrademarkLogo, { tmFontSize } from '../TrademarkLogo';
import StripeLogo from '../assets/Stripe-Favicon-Small.png'
import SSLCert from '../assets/SSL-Safe.png'
import { 
  CardNumberElement, 
  CardExpiryElement, 
  CardCvcElement, 
  useElements, 
  useStripe 
} from "@stripe/react-stripe-js";
import axios from "axios";
import VicktoriaFace from '../assets/Vicktoria_Default.png'; 
import ViewportTracker from '../ViewportTracker';
import { useNavigate } from 'react-router-dom'; // NEW IMPORT

// Plan details used for display and API calls
const PLAN_DETAILS = {
  N: { label: 'Standard',      price: '$30',  period: 'month',  total: '$30',  billing: 'monthly'  },
  A: { label: 'Annual',        price: '$300', period: 'year',   total: '$300', billing: 'annually' },
  E: { label: 'Student / EDU', price: '$20',  period: 'month',  total: '$20',  billing: 'monthly'  },
  O: { label: 'Nonprofit',     price: '$15',  period: 'month',  total: '$15',  billing: 'monthly'  },
};

const PaymentForm = ({ loggedInUser }) => {
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [userName, setUserName] = useState('');
  const [zipCode, setZipCode] = useState('');
  const [error, setError] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate(); // INITIALIZE HOOK

  // Read the plan the user selected on the Pricing page
  const rawPlan = localStorage.getItem('selectedPlan');
  const planCode = Object.keys(PLAN_DETAILS).includes(rawPlan) ? rawPlan : 'N';
  const plan = PLAN_DETAILS[planCode];

  //jump logic copied from Navbar.js
  const handleVicktoriaJump = async () => {
    try {
       const token = localStorage.getItem('token');
        
        // 1. Get the temporary code from main backend
        const response = await fetch('https://vicktoria.ai/api/generate-jump-code', {
            method: 'POST',
            headers: { 
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' 
            }
        });
        
        const data = await response.json();

        // 2. Redirect to VicktoriaAi with the one-time code
        if (data.code) {
            window.location.href = `https://vicka.ai/api/auth/external?code=${data.code}`;
        }
    } catch (err) {
        console.error("Jump failed", error);
    }
  };

  const ELEMENT_OPTIONS = {
    style: {
      base: {
        color: "#ffffff",
        fontSize: "16px",
        fontFamily: "Inter, sans-serif",
        fontSmoothing: "antialiased",
        "::placeholder": { color: "rgba(255,255,255,0.6)" },
      },
      invalid: { color: "#ff8f8f", iconColor: "#ff8f8f" },
    },
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    // Start 10-second lockout
    setIsProcessing(true);
    setTimeout(() => {
        // Only re-enable if the payment hasn't already succeeded
        setIsProcessing(false);
    }, 10000); // 10,000 milliseconds = 10 seconds
    if (!userName || userName.trim().length === 0) {
      setError("Please let Vicktoria know what she should call you.");
      return; 
    }

    if (!zipCode || zipCode.trim().length < 5) {
      setError("Please enter a valid 5-digit ZIP code.");
      return; 
    }

    const { error: stripeError, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardNumberElement),
      billing_details: { address: { postal_code: zipCode } },
    });

    if (!stripeError) {
      try {
        const { id } = paymentMethod;  // ← This line must come FIRST
        const token = localStorage.getItem('token');  // ← Then get the token
        
        const response = await axios.post("https://vicktoria.ai/api/payment", {
            paymentMethodId: id,
            userName: userName,
            email: loggedInUser.email,
            planCode: planCode
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        
        //if (response.data.success) setIsConfirmed(true);
        if (response.data.success) {
          setIsConfirmed(true);
          setTimeout(() => {
            handleVicktoriaJump();
          }, 2000);
        }
      } catch (err) {
        setError("Payment processing failed.");
      }
    } else {
      setError(stripeError.message);
    }
  };

  // --- DATE CALCULATION LOGIC ---
  const today = new Date();
    
  // Create a copy of the date for the future calculation
  const futureDate = new Date(today); 
    
  // Add  days to the future date (automatically handles month rollovers)
  futureDate.setDate(today.getDate() + 14);

  // Format them to readable strings (e.g., "10/25/2023")
  // You can pass 'en-US' or undefined to use the user's local format
  const todayString = today.toLocaleDateString();
  const futureString = futureDate.toLocaleDateString()
  ;
  const textFadeStyle = {
    transition: 'opacity 2s ease-in-out',
    opacity: isConfirmed ? 0.3 : 1
  };

    
  const successOverlayStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 100,
    opacity: isConfirmed ? 1 : 0,
    pointerEvents: isConfirmed ? 'auto' : 'none',
    transition: 'opacity 3s ease-in-out',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  };

  return (
    <div style={{ backgroundColor: '#D1DEE6', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '40px 0', fontFamily: "'Inter', sans-serif" }}>
      <style>
        {`
          .main-corridor {
            display: grid;
            grid-template-columns: 650px 325px;
            gap: 40px;
            width: 1015px; 
            margin: 0 auto;
            position: relative;
            padding-top: 40px;
          }
            .stripe-styled-input::placeholder {
              color: #b7c6d4; /* The color you eyedropped */
              opacity: 1;     /* Ensures Firefox doesn't make it semi-transparent */
            }
          .white-box {
            background-color: white;
            border-radius: 20px;
            padding: 50px;
            box-shadow: 0 10px 30px rgba(0,0,0,0.08);
            height: 650px; 
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
          }
          .mobile-label { display: none; }

          @media screen and (max-width: 800px) {
            .main-corridor { 
              display: flex; 
              flex-direction: column; 
              width: 90%; 
              max-width: 400px; 
              gap: 20px; 
            }
            .white-box { padding: 25px; height: auto !important; min-height: unset; }
            .desktop-labels { display: none !important; }
            .mobile-label { display: block;  color: #ffffff; font-size: 12px; text-align: center; margin-bottom: 4px; }
            .stripe-row { flex-direction: column !important; gap: 15px !important; }
            .stripe-row > div { width: 100% !important; flex: none !important; background-color: #4a7094 } 
            .confirm-btn { width: 100% !important; margin: 20px auto 0 !important; }
            .success-overlay-mobile-hide { display: none !important; }
          }
        `}
      </style>

      <TrademarkLogo
        imgStyle={{ width: '180px', cursor: 'pointer' }}
        imgProps={{ onClick: () => navigate('/') }}
        tmSize={`${tmFontSize({ width: 180 })}px`}
        wrapperStyle={{ marginBottom: '20px' }}
      />

      <div className="main-corridor">
        {/* LEFT BOX: Form */}
        <form onSubmit={handleSubmit} className="white-box">
          <h1 style={{ color: '#2B4B6F', marginBottom: '5px', fontWeight: '700', textAlign: 'center', fontSize: '24px' }}>
            Please enter your card information
          </h1>
          <h5 style={{textAlign: 'center', margin: '5px 0'}}>Payment Secured by Stripe
          <img 
            src={StripeLogo} 
            alt="Stripe Logo"
            style={{ width: '20px', marginLeft: '5px', verticalAlign: 'middle'}}
          />
          </h5>
          <h5 style={{textAlign: 'center', margin: '5px 0'}}>Information Encrypted through SSL
          <img 
            src={SSLCert} 
            alt="SSL Cert"
            style={{ width: '20px', marginLeft: '5px', verticalAlign: 'middle'}}
          />
          </h5>
          
          
          <div style={textFadeStyle}>
            <div style={{ backgroundColor: '#4a7094', padding: '20px', borderRadius: '4px', marginBottom: '25px' }}>
              <div className="desktop-labels" style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: '#B3CFDB', marginBottom: '10px' }}>
                <span style={{ flex: '0 0 45%' }}>CARD NUMBER</span>
                <span style={{ flex: '0 0 15%' }}>MM/YY</span>
                <span style={{ flex: '0 0 15%' }}>CVC</span>
                <span style={{ flex: '0 0 15%' }}>ZIP</span>
              </div>

              <div className="stripe-row" style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                <div style={{ flex: '0 0 45%' }}>
                    <label className="mobile-label">CARD NUMBER</label>
                    <CardNumberElement options={ELEMENT_OPTIONS} />
                </div>
                <div style={{ flex: '0 0 15%' }}>
                    <label className="mobile-label">MM/YY</label>
                    <CardExpiryElement options={ELEMENT_OPTIONS} />
                </div>
                <div style={{ flex: '0 0 15%' }}>
                    <label className="mobile-label">CVC</label>
                    <CardCvcElement options={ELEMENT_OPTIONS} />
                </div>
                <div style={{ flex: '0 0 15%' }}>
                  <label className="mobile-label">ZIP</label>
                  <input 
                    className="stripe-styled-input"
                    type="text" placeholder="11111" value={zipCode}
                    onChange={(e) => setZipCode(e.target.value)}
                    style={{ background: 'transparent', border: 'none', color: '#FFFFFF', fontSize: '16px', width: '100%', outline: 'none', padding: 0, margin: 0, textAlign: 'center' }}
                  />
                </div>
              </div>
            </div>

            <div style={{ backgroundColor: '#B3CFDB', padding: '12px', borderRadius: '15px', textAlign: 'center', marginBottom: '10px' }}>
                <label style={{ color: '#2B4B6F', fontWeight: 'bold' }}>What should Vicktoria call you?</label>
            </div>
            
            <input 
              style={{ padding: '12px', backgroundColor: '#D1DEE6', borderRadius: '8px', border: 'none', width: '200px', textAlign: 'center', display: 'block', margin: '0 auto' }}
              placeholder="Name" value={userName} onChange={(e) => setUserName(e.target.value)}
              disabled={isConfirmed}
            />
            {error && <p style={{ color: '#ff8f8f', marginTop: '15px', textAlign: 'center' }}>{error}</p>}
          </div>

          <button 
            className="confirm-btn" 
            type="submit" 
            // Disable if confirmed OR if in the 10s processing window
            disabled={isConfirmed || isProcessing} 
            style={{
                ...textFadeStyle, 
                // Fade to 40% opacity when locked out
                opacity: (isConfirmed || isProcessing) ? 0.4 : 1, 
                cursor: (isConfirmed || isProcessing) ? 'not-allowed' : 'pointer',
                transition: 'opacity 0.5s ease', // Smooth fade
                width: '250px', 
                marginTop: '30px', 
                backgroundColor: '#4a7094', 
                color: 'white', 
                padding: '15px', 
                borderRadius: '10px', 
                fontWeight: 'bold', 
                border: 'none'
            }}
        >
            {isProcessing ? "Processing..." : "Confirm Subscription"}
        </button>
        </form>

        {/* RIGHT BOX: Details */}
        <div className="white-box">
          <h3 style={{ color: '#2B4B6F', borderBottom: '1px solid #D1DEE6', paddingBottom: '10px' }}>Transaction Details</h3>
          <div style={textFadeStyle}>
            <h5 style={{ fontSize: '14px', marginTop: '15px' }}>
              - Vicktoria AI™ {plan.label} plan ({plan.price}/{plan.period})
            </h5>
            {/* Free trial is granted at signup (no credit card required).
                By the time a user reaches this page their trial has been used,
                so billing always starts today. */}
            <h5 style={{ fontSize: '14px' }}>- Cancel anytime</h5>
            <h5 style={{ fontSize: '14px', visibility: 'hidden' }}>- Cancel anytime</h5>
            <h3 style={{ color: '#2B4B6F', borderBottom: '1px solid #D1DEE6', paddingBottom: '10px', marginTop: '10px' }}></h3>
            <h3 style={{ color: '#2B4B6F', marginTop: '20px' }}>
              Total for today: {plan.total}
            </h3>
          </div>
          {isConfirmed && <h1 style={{ color: '#3ABE12', textAlign: 'center', marginTop: '10px', fontSize: '28px' }}>Purchase successful</h1>}
          <div style={{ marginTop: 'auto', borderTop: '1px solid #D1DEE6', paddingTop: '20px' }}>
            <div style={textFadeStyle}>
              <span style={{ fontSize: '24px', fontWeight: 'bold', lineHeight: '1.2', display: 'block' }}>
                {`Billing period will begin as of ${todayString}. Billing will occur ${plan.billing} afterwards.`}
              </span>
            </div>
          </div>
        </div>


        {/* SUCCESS OVERLAY (Desktop Only) */}
        <div className="success-overlay-mobile-hide" style={successOverlayStyle}>
          <img src={VicktoriaFace} alt="Vicktoria" style={{ width: '175px', borderRadius: '20px', border: '8px solid #B3CFDB', marginBottom: '20px', marginTop: '250px', marginRight: '75px' }} />
          <div style={{ backgroundColor: '#B3CFDB', padding: '20px', borderRadius: '30px', textAlign: 'center', marginRight: '175px' }}>
            <p style={{ fontWeight: '500', margin: 0 }}>
              I look forward to working with you, {userName || 'Guest'}! Let’s go to the main chat interface to <span style={{ color: '#1155CC', cursor: 'pointer' }} onClick={handleVicktoriaJump}><u>get started.</u></span>
            </p>
          </div>
        </div>
      </div>
      <ViewportTracker />
    </div>
  );
};

export default PaymentForm;

